/* Maison Nathael — Tote bag offert (choix obligatoire avant de passer commande).
   - Tant qu'aucun choix n'est dans le panier, un encadré propose : Crème / Noir / Je ne veux pas.
   - Le choix ajoute la variante correspondante du produit « Tote Bag Offert » (0 €) et l'encadré disparaît.
   - Pour changer d'avis, la cliente supprime la ligne : l'encadré réapparaît.
   - Protection : jamais plus d'UNE ligne tote bag (toutes variantes confondues), quantité 1,
     et pas de tote si le panier ne contient rien d'autre.
   - Anti « achat trop rapide » :
       * l'état du panier est connu dès le chargement (window.MN_TOTE_CART, écrit en Liquid) ;
       * chaque ajout / modification du panier (fetch ou XHR du thème) est suivi immédiatement ;
       * tant que l'état n'est pas confirmé, « Passer la commande » est bloqué et l'encadré s'affiche ;
       * les boutons de paiement express du panier (Apple Pay, Shop Pay…) restent masqués tant que le choix n'est pas fait.
   - Textes en français ou en anglais selon la langue du site (window.MN_I18N, défini dans nathael-styles). */
(function () {
  var VARIANTS = { 'Crème': 55896423268677, 'Noir': 55896423235909, 'Je ne veux pas': 55896423301445 };
  var TOTE_IDS = [VARIANTS['Crème'], VARIANTS['Noir'], VARIANTS['Je ne veux pas']];
  var OPTIONS = ['Crème', 'Noir', 'Je ne veux pas'];
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var T = window.MN_I18N || {
    toteTitle: 'Tote bag offert',
    toteText: 'Choisissez votre couleur ou refusez-le pour éviter la surconsommation.',
    toteMsg: 'Merci de faire votre choix pour le tote bag avant de passer commande.',
    opts: {}
  };

  var hasChoice = false;
  var realCount = 0;
  var loaded = false;
  var busy = null;      /* promesse en cours (lecture / écriture du panier) */
  var external = 0;     /* requêtes panier du thème en cours */

  /* ---------- État initial, sans attendre le réseau ---------- */
  function applyCart(cart) {
    var toteQty = 0;
    var choice = false;
    (cart.items || []).forEach(function (it) {
      if (TOTE_IDS.indexOf(it.variant_id) > -1) { toteQty += it.quantity; choice = true; }
    });
    realCount = (cart.item_count || 0) - toteQty;
    hasChoice = choice && realCount > 0;
  }
  if (window.MN_TOTE_CART) { applyCart(window.MN_TOTE_CART); loaded = true; }

  function pending() { return realCount > 0 && !hasChoice; }
  function locked() { return !loaded || !!busy || external > 0 || pending(); }

  /* ---------- Réseau ---------- */
  var nativeFetch = window.fetch.bind(window);
  function api(url, body) {
    return nativeFetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-MN-Tote': '1' },
      body: body ? JSON.stringify(body) : undefined,
      cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  function refreshThemeCart() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* Met le panier en ordre ; renvoie true s'il a fallu le modifier. */
  function sanitize(cart) {
    var toteLines = cart.items.filter(function (it) { return TOTE_IDS.indexOf(it.variant_id) > -1; });
    applyCart(cart);
    var updates = {};
    var keep = realCount > 0 ? toteLines[0] || null : null; /* on garde le premier choix */
    toteLines.forEach(function (it) {
      if (keep && it.key === keep.key) { if (it.quantity !== 1) updates[it.key] = 1; }
      else updates[it.key] = 0;
    });
    hasChoice = !!keep;

    var body = {};
    if (Object.keys(updates).length) body.updates = updates;
    if ((cart.attributes || {})['Tote bag offert']) body.attributes = { 'Tote bag offert': '' }; /* nettoyage d'un ancien essai */
    if (!body.updates && !body.attributes) return Promise.resolve(false);
    return api('/cart/update.js', body).then(function () { return !!body.updates; });
  }

  function loadCart() {
    if (busy) return busy.then(function () { return loadCart(); });
    render();
    busy = api('/cart.js').then(function (cart) {
      return sanitize(cart).then(function (changed) {
        loaded = true;
        if (changed) refreshThemeCart();
      });
    }).catch(function () {}).then(function () { busy = null; render(); });
    return busy;
  }

  function choose(label) {
    if (busy || !VARIANTS[label]) return;
    hasChoice = true;
    render();
    busy = api('/cart.js').then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (TOTE_IDS.indexOf(it.variant_id) > -1) updates[it.key] = 0; });
      return Object.keys(updates).length ? api('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return api('/cart/add.js', { items: [{ id: VARIANTS[label], quantity: 1 }] });
    }).catch(function () { hasChoice = false; }).then(function () {
      busy = null;
      closeModal();
      render();
      refreshThemeCart();
    });
  }

  /* ---------- Fenêtre (pop-up) juste après l'ajout au panier ---------- */
  var modal = null;
  function openModal() {
    if (!pending()) return;
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'mn-tote-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="mn-tote-modal__card">' +
        '<p class="mn-tote-modal__kicker">' + (T.modalKicker || 'Article ajouté au panier ✓') + '</p>' +
        '<p class="mn-tote__title">' + T.toteTitle + '</p>' +
        '<p class="mn-tote__text">' + T.toteText + '</p>' +
        '<div class="mn-tote__opts">' + OPTIONS.map(function (o) {
          return '<button type="button" class="mn-tote__opt" data-value="' + o + '">' + ((T.opts && T.opts[o]) || o) + '</button>';
        }).join('') + '</div></div>';
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    document.documentElement.classList.add('mn-tote-modal-open');
    var first = modal.querySelector('.mn-tote__opt');
    if (first) first.focus({ preventScroll: true });
  }
  function closeModal() {
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('mn-tote-modal-open');
  }

  /* Suivre immédiatement chaque modification du panier faite par le thème */
  function isCartWrite(url, init) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (!CART_RE.test(u.split('#')[0].replace(location.origin, ''))) return false;
      var h = init && init.headers;
      if (h && ((h.get && h.get('X-MN-Tote')) || h['X-MN-Tote'])) return false;
      return true;
    } catch (e) { return false; }
  }
  function isAdd(url) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    return /\/cart\/add/.test(u);
  }
  function afterWrite(add) {
    external = Math.max(0, external - 1);
    loadCart().then(function () { if (add) openModal(); });
  }
  window.fetch = function (url, init) {
    if (!isCartWrite(url, init)) return nativeFetch(url, init);
    var add = isAdd(url);
    external++;
    render();
    var p = nativeFetch(url, init);
    p.then(function () { afterWrite(add); }, function () { afterWrite(false); });
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.__mnCart = isCartWrite(String(url));
    this.__mnAdd = isAdd(String(url));
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__mnCart) {
      var add = this.__mnAdd;
      external++;
      render();
      this.addEventListener('loadend', function () { afterWrite(add); });
    }
    return xSend.apply(this, arguments);
  };

  /* ---------- Affichage ---------- */
  function buildBlock() {
    var box = document.createElement('div');
    box.className = 'mn-tote';
    var html = '<p class="mn-tote__title">' + T.toteTitle + '</p>' +
      '<p class="mn-tote__text">' + T.toteText + '</p>' +
      '<div class="mn-tote__opts">';
    OPTIONS.forEach(function (o) {
      html += '<button type="button" class="mn-tote__opt" data-value="' + o + '">' + ((T.opts && T.opts[o]) || o) + '</button>';
    });
    html += '</div><p class="mn-tote__msg" role="alert" hidden>' + T.toteMsg + '</p>';
    box.innerHTML = html;
    return box;
  }

  var rendering = false;
  function render() {
    if (rendering) return;
    rendering = true;
    try {
      var show = loaded ? pending() : false;
      var lock = locked();
      var root = document.documentElement;
      if (root.classList.contains('mn-tote-pending') !== show) root.classList.toggle('mn-tote-pending', show);
      var ok = loaded && !busy && external === 0 && !pending();
      if (root.classList.contains('mn-tote-ok') !== ok) root.classList.toggle('mn-tote-ok', ok);

      document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
        var form = btn.form || btn.closest('form') || btn.parentNode;
        if (!form) return;
        var block = form.querySelector('.mn-tote');
        if (show && !block) {
          var host = btn.closest('.button-group') || btn;
          block = buildBlock();
          host.parentNode.insertBefore(block, host);
        }
        if (block && block.hidden !== !show) block.hidden = !show;
        if (btn.classList.contains('mn-tote-locked') !== lock) btn.classList.toggle('mn-tote-locked', lock);
        var aria = lock ? 'true' : 'false';
        if (btn.getAttribute('aria-disabled') !== aria) btn.setAttribute('aria-disabled', aria);
      });
    } finally { rendering = false; }
  }

  function showMessage(btn) {
    var form = btn.form || btn.closest('form') || btn.parentNode;
    var block = form && form.querySelector('.mn-tote');
    if (!block) return;
    block.querySelector('.mn-tote__msg').hidden = false;
    block.classList.add('mn-tote--alert');
    setTimeout(function () { block.classList.remove('mn-tote--alert'); }, 900);
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Clic trop rapide : on bloque, on vérifie le panier, puis on montre le choix */
  function guard(e, btn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var wait = busy || (loaded ? null : loadCart());
    if (wait || external > 0) {
      Promise.resolve(wait).then(function () { render(); if (pending()) { showMessage(btn); openModal(); } });
    } else {
      render();
      showMessage(btn);
      openModal();
    }
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.mn-tote__opt');
    if (opt) {
      e.preventDefault();
      e.stopPropagation();
      choose(opt.getAttribute('data-value'));
      return;
    }
    var co = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (co && locked()) guard(e, co);
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    var toCheckout = (sub && sub.name === 'checkout') || /\/checkout/.test(e.target.getAttribute('action') || '');
    if (toCheckout && locked()) guard(e, sub || e.target);
  }, true);

  document.addEventListener('cart:refresh', function () { if (!busy) loadCart(); });

  var queued = false;
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return el && !(el.closest && el.closest('.mn-tote'));
    });
    if (!relevant || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; render(); });
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    render();
    loadCart(); /* confirmation en arrière-plan */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
